import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchHomeOwnerOnboarding = (_, { payload }) => {    
  return payload
}

const clearHomeOwnerOnboarding = () =>{
  return []
}

const deleteHomeownerOrderData = (state, { payload }) => {
  return state.filter(od => od.id !== payload)
}
const initialState = [];

export default createReducer(initialState, {
//   [TYPES.HOMEOWNER_ONBOARDING_DATA]: setHomeownerOnboardingData,
  [TYPES.FETCH_HOMEOWNER_ONBOARDING_DATA]: fetchHomeOwnerOnboarding,
  [TYPES.CLEAR_HOMEOWNER_ONBOARDING_DATA]: clearHomeOwnerOnboarding,
  [TYPES.DELETE_HOMEOWNER_ONBOARDING_ORDER_DATA] : deleteHomeownerOrderData
//   [TYPES.CLEAR_HOMEOWNER_ONBOARDING_FORM_DATA]: clearsetHomeownerOnboardingFormData
});
